import { useState,useEffect } from "react";
import { After, BackGroundImage, Before } from "../../../assets/services";
import { Link, useNavigate } from "react-router-dom";
import { BiSolidBriefcaseAlt2 } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { fetchServices } from "../../../redux/actions/serviceActions";
function formatNumber(value) {
  const num = Number(value);
  return num % 1 === 0 ? num : num.toFixed(2);
}
export default function SectionTwo() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const storedUser = localStorage.getItem("customeruser");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const [filterOptions, setFilterOptions] = useState({
    launchStatus: "all",
  });

  const itemsPerPage = 10;

  const { service,totalRecords, error } = useSelector(
    (state) => state.serviceState
  );

  const dispatch=useDispatch();

  useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true);
      dispatch(fetchServices(currentPage,itemsPerPage,searchTerm)); 
    } finally {
      setLoading(false);
    }
  };

  fetchData();
  }, [dispatch,currentPage,itemsPerPage,searchTerm]);

  const applyFilters = (items) => {
    return items.filter((item) => {

      const launchMatch =
        filterOptions.launchStatus === "all" ||
        (item.displaySections?.includes(filterOptions.launchStatus));

      return launchMatch ;
    });
  };

  const handleSearch = (data) => {
  if (!searchTerm.trim()) return data;

  const term = searchTerm.toLowerCase().trim();

  return data.filter((item) => {
    const serviceNameMatch = item.serviceName?.toLowerCase().includes(term);
  
    return serviceNameMatch ;
  });
  };

  const handleBookService = (id,title) => {
      if (storedUser) {
        navigate("/bookservice", { state: { id: id, title: title } });
      } else {
        toast.warning("Please login to continue");
        setTimeout(() => navigate("/login"), 1000);
        return;
      }
  };

  const totalPages = Math.ceil(totalRecords/ itemsPerPage);
 
  const currentItems = handleSearch(applyFilters(service));

  if (loading) {
    return <p className="text-center mt-10">Loading sevices...</p>;
  }

  if(error)
  {
    return(
      <p className="text-red-600">service error : {error}</p>
    );
  }
  return (
    <section className="pb-8 md:pb-10 xl:pb-14">
      <div className="flex flex-row space-x-3 justify-end px-5 md:px-10 xl:px-14 my-4">
        <input
          type="text"
          placeholder="Search services..."
          className="p-2 border border-gray-500 rounded focus:outline-none w-full max-w-xs"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1); 
          }}
        />
        <div className="flex flex-row h-10 items-center">
              <label className="block font-semibold text-xs md:text-sm xl:text-base w-1/3">Filter by : </label>
              <select
                value={filterOptions.launchStatus}
                onChange={(e) =>
                  setFilterOptions({ ...filterOptions, launchStatus: e.target.value })
                }
                className="w-2/3 px-2 py-1 border rounded"
              >
                <option value="All">All Sections</option>
                <option value="General">General</option>
                <option value="popular">Popular</option>
                <option value="Offers & Discount">Offers & Discounts</option>
              </select>
        </div>

      </div>

      <div className="grid gap-x-3 md:gap-x-8 gap-y-7 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 px-5 md:px-10 xl:px-14">
        {currentItems.length === 0 ? (
          <p className="text-center col-span-full text-gray-700 font-semibold py-8">
            No services found matching your filter.
          </p>
        ) : (
          currentItems.map((data, index) => (
            <div
              key={index}
              className="rounded-lg shadow bg-gray-100 flex flex-col justify-between pt-2 gap-5"
            >
              <Link to={`/servicedetail/${data.id}`}>
              <div className="relative">
                <img
                  src={data.images?.[0].image}
                  alt={data.serviceName}
                  className="w-full h-48 object-contain pt-5"
                />

                <div className="absolute top-2 left-2 bg-green-600 text-white text-xs font-semibold px-2 py-1 rounded-full">
                  {formatNumber(data.discountPercent)}% OFF
                </div>
              </div>             
              </Link>
              <div className="flex flex-col bg-gradient-to-b from-[#E96364] to-[#FEB5B6] py-2 px-3 rounded-lg text-white">
                <Link to={`/servicedetail/${data.id}`}>
                <div className="flex ">
                  <h2 className="text-base xl:text-lg font-semibold">
                    {data.serviceName}
                  </h2>
                </div>
                </Link>
                <div className="flex flex-row justify-between space-x-2">
                  <Link to={`/servicedetail/${data.id}`}>
                  <div className="flex flex-row space-x-3 text-sm md:text-base justify-between">
                    <p>Starts from ₹{formatNumber(data.price)}</p>
                    <p className="line-through text-gray-200">
                      ₹{formatNumber(data.oldPrice)}
                    </p>
                  </div>
                  </Link>
                  <div className="flex justify-end items-end bg-white rounded-full p-2">
                      <button
                        onClick={() => handleBookService(data.id, data.serviceName)}
                        className="text-xl text-[#A63F40] hover:text-[#7b2f30] transition"
                      >
                        <BiSolidBriefcaseAlt2 />
                      </button>
                  </div>
                </div>
                
              </div>
            </div>
          ))
        )}
      </div>

      {totalPages > 1 && (
        <div className="flex justify-center items-center gap-2 mt-10 flex-wrap">
          <button
            onClick={() => setCurrentPage(1)}
            disabled={currentPage === 1}
            className="px-2 py-1 text-sm rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
          >
            {"<<"}
          </button>
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className="px-2 py-1 text-sm rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
          >
            {"<"}
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter((page) =>
              page === 1 ||
              page === totalPages ||
              Math.abs(currentPage - page) <= 1
            )
            .reduce((acc, page, i, arr) => {
              if (i > 0 && page - arr[i - 1] > 1) acc.push("...");
              acc.push(page);
              return acc;
            }, [])
            .map((page, i) =>
              page === "..." ? (
                <span key={`dots-${i}`} className="px-2 py-1 text-sm text-gray-500">...</span>
              ) : (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={`px-3 py-1 text-sm rounded border font-medium ${
                    currentPage === page
                      ? "bg-pink-600 text-white"
                      : "hover:bg-pink-100"
                  }`}
                >
                  {page}
                </button>
              )
            )}

          <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
            className="px-2 py-1 text-sm rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
          >
            {">"}
          </button>
          <button
            onClick={() => setCurrentPage(totalPages)}
            disabled={currentPage === totalPages}
            className="px-2 py-1 text-sm rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
          >
            {">>"}
          </button>
        </div>
      )}

      <div className="flex flex-row bg-cover bg-center mt-8 md:mt-10 p-2  md:p-5"
      style={{ backgroundImage: `url(${BackGroundImage})` }}>
        <div className="w-1/4 md:w-1/3 flex justify-center items-center">
          <p className="text-white font-semibold text-xl md:text-3xl w-20 text-center">Results You Can See</p>
        </div>
        <div className="w-3/4 md:w-2/3 bg-[#DEDEDE] p-2 md:p-4 rounded-lg flex flex-row space-x-2 justify-between">
            <div className="md:p-4 flex flex-col items-center">
               <img src={Before}/>
               <p className="text-sm md:text-base xl:text-lg font-medium">Before</p>
            </div>
            <div className="md:p-4 flex flex-col items-center">
               <img src={After}/>
               <p className="text-sm md:text-base xl:text-lg font-medium">After</p>
            </div>
        </div>
      </div>
    </section>
  );
}
